if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      this.productInfo = document.getElementById(`ProductInfo-${this.dataset.section}`);
      this.prependMedia = this.dataset.disablePrepend != 'true';
      if (this.productInfo && Shopify.postLinksRetry) this.productInfo.initShareLinks();
      this.filteringOption = this.dataset.filteringOption;
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    connectedCallback() {
      this.onVariantChange = (event) => {
        const picker = event.target.closest('variant-selects, variant-radios');
        if (!picker || picker.dataset.section !== this.dataset.section) return;
        if (customElements.get(picker.localName)) return;
        const json = picker.querySelector('script[type="application/json"]');
        if (!json) return;
        const options = Array.from(picker.querySelectorAll('.product-form__input')).map((group) => {
          return group.querySelector('select, input[type="radio"]:checked')?.value;
        });
        let variants;
        try { variants = JSON.parse(json.textContent); } catch { return; }
        const variant = variants.find((item) => item.options.length === options.length &&
          item.options.every((value, index) => value === options[index]));
        if (!variant) return;
        const mediaId = variant.featured_media ? `${this.dataset.section}-${variant.featured_media.id}` : null;
        this.setActiveMedia(mediaId, true, Boolean(this.filteringOption), variant);
      };
      document.addEventListener('change', this.onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('change', this.onVariantChange);
      window.clearTimeout(this.mediaScrollTimeout);
    }

    onSlideChanged(event) {
      if (!event.detail.currentElement) return;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, filtering = false, currentVariant = null) {
      let activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (filtering && currentVariant) {
        const matches = (slide) => slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display';
        if (!activeMedia || !matches(activeMedia)) {
          activeMedia = Array.from(this.elements.viewer.querySelectorAll('[data-media-id]')).find(matches);
        }
      }
      if (!activeMedia) return;
      mediaId = activeMedia.dataset.mediaId;
      if (filtering && currentVariant) {
        const allSlides = this.querySelectorAll('.product__media-item, .thumbnail-list__item, .slider-counter__link');
        allSlides.forEach(slide => {
          if (slide.dataset.alt === currentVariant[this.filteringOption] || slide.dataset.alt === 'always_display') {
            slide.classList.remove('hidden');
          } else {
            slide.classList.add('hidden');
          }
        })
      }

      this.querySelectorAll('.product__media-item--variant, .thumbnail-list_item--variant, [data-variant-media]').forEach((slide) => {
        slide.dataset.variantMedia = 'true';
        const selected = (slide.dataset.mediaId || slide.dataset.target) === mediaId;
        slide.classList.toggle('hidden', !selected);
        slide.classList.toggle(slide.dataset.mediaId ? 'product__media-item--variant' : 'thumbnail-list_item--variant', !selected);
      });
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend && this.prependMedia) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
      }

      [this.elements.viewer, this.elements.thumbnails].forEach((slider) => {
        if (!slider?.slider || !slider.resetPages) return;
        const visible = Array.from(slider.querySelectorAll('[id^="Slide-"]')).filter((slide) => slide.clientWidth > 0);
        if (!visible.length) return;
        if (visible.length === 1) {
          slider.sliderItemOffset = Math.max(visible[0].clientWidth, 1);
          slider.totalPages = 1;
          slider.slider.scrollTo({ left: 0, top: 0 });
        }
        slider.resetPages();
        slider.update();
      });

      this.preventStickyHeader();
      window.clearTimeout(this.mediaScrollTimeout);
      this.mediaScrollTimeout = window.setTimeout(() => {
        if (!this.getClientRects().length) return;
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, false, 10, true)) return;

      if (this.elements.thumbnails.vertical) {
        console.log('setActiveThumbnail')
        this.elements.thumbnails.slider.scrollTo({ top: thumbnail.offsetTop });
      } else {
        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
